<template>
  <section class="intro">
    <div class="intro-content">
    </div>
  </section>
</template>

<script>
export default {
  name: 'Intro',
};
</script>

<style lang="postcss" scoped>
  h1,
  p {
    font-weight: 700;
    margin-bottom: var(--base-gap);
  }

  .btn {
    padding: 15px 45px;
 }
  .button-start {
    display: flex;
    justify-content: center;
  }
  .warning {
    margin-top: var(--base-gap);
  }

  p.small {
    font-size: var(--font-size-small);
  }

  .intro {
    position: relative;
  }

  .intro-content {
    position: relative;
    z-index: 1;
  }

  .intro-text {
    margin-bottom: var(--base-gap);
  }
</style>
